@if (loading()) {
  <div class="tt-offline-guideline-view_loading">
    <tt-spinner />
  </div>
} @else {
  <shared-main-sidebar [readonly]="true">
    <tt-drawer-container>
      <tt-drawer
        class="tt-offline-guideline-view_sidebar"
        ttDrawerRight
        [minWidth]="0"
        [opened]="false"
        [resizable]="false"
        [showToggle]="false" />

      <tt-drawer-content cdkScrollable class="tt-offline-guideline-view_container" id="tt-flowchart-touch-scroller">
        <smartbook-content class="tt-offline-guideline-view_smartbook-content" id="smartbook-content" />
      </tt-drawer-content>
    </tt-drawer-container>
  </shared-main-sidebar>

  <smartbook-footer-component
    [allowExportAsPdf]="false"
    [publishedAt]="guidelineService.guidelineData().publishedAt"
    [version]="guidelineService.guidelineData().version" />
}
